import NSInfoBanner, { INSInfoBannerProps } from 'components/NSInfoBanner/NSInfoBanner';
import React, { useEffect } from 'react';
import BannerNavigator from './BannerNavigator';

export interface IBannerCarouselProps {
    bannersData: INSInfoBannerProps[]
}

const BannerCarousel = ({ bannersData }: IBannerCarouselProps) => {
    const [currentBanner, setCurrentBanner] = React.useState(0);

    useEffect(() => {
        if (currentBanner >= bannersData.length) setCurrentBanner(bannersData.length - 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bannersData]);

    return (
        <NSInfoBanner
            {...bannersData[currentBanner]}
            carouselNavigator={
                bannersData.length > 1 && (
                    <BannerNavigator currentBanner={currentBanner} setCurrentBanner={setCurrentBanner} countBanners={bannersData.length} />
                )
            }
        />
    );
};

export default BannerCarousel;
